import { ToggleSwitch as UnionSwitch } from '@xo-union/tk-component-switches';
import { FieldProps } from 'formik';
import React from 'react';

import { SetFieldValue } from './common';

export interface Props extends FieldProps {
  checked: string;
  setFieldValue: SetFieldValue;
  enabledText?: string;
  disabledText?: string;
  'aria-label'?: string;
}

export const ToggleSwitch: React.FC<Props> = ({
  field,
  setFieldValue,
  enabledText = 'Yes',
  disabledText = 'No',
  'aria-label': ariaLabel = '',
}: Props) => {
  const { name, value: checked } = field;
  // @ts-ignore
  const onChange = (e): void => {
    setFieldValue(name, e.target.checked);
  };

  return (
    <UnionSwitch
      data-testid="switch"
      labelDirection="left"
      onChange={onChange}
      aria-label={ariaLabel} // For accessibility
      checked={checked}
    >
      {checked ? enabledText : disabledText}
    </UnionSwitch>
  );
};
